import { withStyles, TableCell } from '@material-ui/core';

const StyledTableRowCell = withStyles((theme) => ({
  root: {
    padding: '6px',
  },
  body: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    color: theme.printTableLabel,
    borderRight: `1px solid ${theme.printTableBorder}`,
    '&:last-child': {
      borderRight: 'none',
    },
  }
}))(({ style, ...props }) => (
  <TableCell style={{ ...style }} {...props} />
));

export default StyledTableRowCell;
